module.exports = __webpack_public_path__ + "static/media/Icons-Navigation-Logout.067a14fa.svg";